import React from 'react';
import { Flex } from '@chakra-ui/layout';
import { ProductButton } from './ProductButton';
import PRO_ZD801 from 'assets/products/PRO-ZD801.png';
import SGV_2020 from 'assets/products/SGV-2020.png';
import EFB_PCTH from 'assets/products/EFB-PCTH.png';
import IRC_150 from 'assets/products/IRC-150.png';
import HTW_110PN from 'assets/products/HTW-110PN.png';
import HTW_110BL from 'assets/products/HTW-110BL.png';

export const ProductButtons = React.memo(() => {
  return (
    <Flex flexDirection="column" mt={2} mb={8} width="100%" alignItems="center">
      <Flex justifyContent="center" flexWrap="wrap" maxWidth={1200}>
        <ProductButton src={PRO_ZD801} title="自然養生機" code="PRO-ZD801" />
        <ProductButton
          src={SGV_2020}
          title="迷你多功能蒸烤焗爐"
          code="SGV-2020"
        />
        <ProductButton
          src={EFB_PCTH}
          title="UV-C 空氣淨化風扇暖風機"
          code="EFB-PCTH"
        />
        <ProductButton src={IRC_150} title="IH多功能電飯煲" code="IRC-150" />
        <ProductButton
          src={HTW_110PN}
          title="移動浴室寶 - 粉紅色"
          code="HTW-111PN"
          anchor="HTW-111"
        />
        <ProductButton
          src={HTW_110BL}
          title="移動浴室寶 - 藍色"
          code="HTW-111BL"
          anchor="HTW-111"
        />
      </Flex>
    </Flex>
  );
});
